export const dateFormat = {
  today: $localize`:|localized date today @@p1-date-format.constant_date-today:Today`,
  yesterday: $localize`:|localized date yesterday @@p1-date-format.constant_date-yesterday:Yesterday`
};
